import React from "react";
import store from "../../store/global";
import {Observer} from "cellx-react";


@Observer
class Result extends React.Component<any, any>{

    render() {
        return (
            <div style={{width: "100%"}}>
                <div className="app-container" >{store.globalLoading ? "Загрузка..." : store.result}</div>
            </div>
            );
    }
}

export default Result;
